import { render, staticRenderFns } from "./VerifyEmailFail.vue?vue&type=template&id=6f7dd590&scoped=true&"
import script from "./VerifyEmailFail.vue?vue&type=script&lang=js&"
export * from "./VerifyEmailFail.vue?vue&type=script&lang=js&"
import style0 from "./VerifyEmailFail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./VerifyEmailFail.vue?vue&type=style&index=1&id=6f7dd590&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7dd590",
  null
  
)

export default component.exports